/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  CardOverviewResponse,
  UtxCardOverviewGetCardOverviewParams,
  CardUnmaskResponse,
  ReplaceCardResponse,
  ReplaceCardRequest,
  CardSpendingResponse,
  UtxCardOverviewGetSpendingParams
} from './schema'



export const utxCardOverviewGetCardOverview = (
    params?: UtxCardOverviewGetCardOverviewParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardOverviewResponse>> => {
    return axios.get(
      `/card/overview`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxCardOverviewGetCardOverviewQueryKey = (params?: UtxCardOverviewGetCardOverviewParams,) => [`/card/overview`, ...(params ? [params]: [])];

    
export type UtxCardOverviewGetCardOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardOverviewGetCardOverview>>>
export type UtxCardOverviewGetCardOverviewQueryError = AxiosError<unknown>

export const useUtxCardOverviewGetCardOverview = <TData = Awaited<ReturnType<typeof utxCardOverviewGetCardOverview>>, TError = AxiosError<unknown>>(
 params?: UtxCardOverviewGetCardOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardOverviewGetCardOverview>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardOverviewGetCardOverviewQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardOverviewGetCardOverview>>> = ({ signal }) => utxCardOverviewGetCardOverview(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardOverviewGetCardOverview>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardOverviewGetCardDetail = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardUnmaskResponse>> => {
    return axios.get(
      `/card/${id}/unmask`,options
    );
  }


export const getUtxCardOverviewGetCardDetailQueryKey = (id: string,) => [`/card/${id}/unmask`];

    
export type UtxCardOverviewGetCardDetailQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardOverviewGetCardDetail>>>
export type UtxCardOverviewGetCardDetailQueryError = AxiosError<unknown>

export const useUtxCardOverviewGetCardDetail = <TData = Awaited<ReturnType<typeof utxCardOverviewGetCardDetail>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardOverviewGetCardDetail>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardOverviewGetCardDetailQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardOverviewGetCardDetail>>> = ({ signal }) => utxCardOverviewGetCardDetail(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardOverviewGetCardDetail>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardOverviewReplaceCard = (
    id: string,
    replaceCardRequest: ReplaceCardRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReplaceCardResponse>> => {
    return axios.post(
      `/card/${id}/replace`,
      replaceCardRequest,options
    );
  }



    export type UtxCardOverviewReplaceCardMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardOverviewReplaceCard>>>
    export type UtxCardOverviewReplaceCardMutationBody = ReplaceCardRequest
    export type UtxCardOverviewReplaceCardMutationError = AxiosError<unknown>

    export const useUtxCardOverviewReplaceCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardOverviewReplaceCard>>, TError,{id: string;data: ReplaceCardRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardOverviewReplaceCard>>, {id: string;data: ReplaceCardRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardOverviewReplaceCard(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardOverviewReplaceCard>>, TError, {id: string;data: ReplaceCardRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardOverviewGetSpending = (
    id: string,
    params?: UtxCardOverviewGetSpendingParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardSpendingResponse>> => {
    return axios.get(
      `/card/${id}/spending`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxCardOverviewGetSpendingQueryKey = (id: string,
    params?: UtxCardOverviewGetSpendingParams,) => [`/card/${id}/spending`, ...(params ? [params]: [])];

    
export type UtxCardOverviewGetSpendingQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardOverviewGetSpending>>>
export type UtxCardOverviewGetSpendingQueryError = AxiosError<unknown>

export const useUtxCardOverviewGetSpending = <TData = Awaited<ReturnType<typeof utxCardOverviewGetSpending>>, TError = AxiosError<unknown>>(
 id: string,
    params?: UtxCardOverviewGetSpendingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardOverviewGetSpending>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardOverviewGetSpendingQueryKey(id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardOverviewGetSpending>>> = ({ signal }) => utxCardOverviewGetSpending(id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardOverviewGetSpending>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

